import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n	color: ",
        ";\n	font-size: inherit;\n	text-decoration: ",
        ";\n	cursor: pointer;\n\n	margin-left: ",
        ";\n\n	&:hover {\n		color: ",
        ";\n	}\n\n	&:focus-visible {\n		box-shadow: rgb(192 210 251) 0px 0px 0px 3px;\n	}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { darken, lighten } from "polished";
import React from "react";
import styled from "styled-components";
import ButtonBase from "~/components/ButtonBase";
var DEFAULT_PROPS = {
    color: "default",
    leftGutter: false,
    underline: true
};
// Default styles for links that occur in body text
var LinkBody = styled(ButtonBase).attrs(function(param) {
    var color = param.color, leftGutter = param.leftGutter, underline = param.underline;
    return {
        color: color !== null && color !== void 0 ? color : DEFAULT_PROPS.color,
        leftGutter: leftGutter !== null && leftGutter !== void 0 ? leftGutter : DEFAULT_PROPS.leftGutter,
        underline: underline !== null && underline !== void 0 ? underline : DEFAULT_PROPS.underline
    };
}).withConfig({
    componentId: "sc-92e91841-0"
})(_templateObject(), function(props) {
    return ({
        default: props.theme.colors.primary.dark,
        primaryLight: props.theme.colors.primary.light,
        onPrimary: props.theme.colors.primary.contrastText,
        white: props.theme.colors.white
    })[props.color];
}, function(props) {
    return props.underline ? "underline" : "none";
}, function(param) {
    var leftGutter = param.leftGutter;
    return leftGutter ? "4px" : "0";
}, function(props) {
    return ({
        default: lighten(0.1, props.theme.colors.primary.dark),
        primaryLight: lighten(0.1, props.theme.colors.primary.light),
        onPrimary: darken(0.1, props.theme.colors.primary.contrastText),
        white: darken(0.1, props.theme.colors.white)
    })[props.color];
});
LinkBody.defaultProps = DEFAULT_PROPS;
export default /*#__PURE__*/ React.memo(LinkBody);
